import dayjs from 'dayjs';

export default function(value) {
    /**
     * Formats a date
     * Example: 2019-08-21T09:58:23.284Z => 08/21/2019
     * @param {String} value
     * @return {String}
     */
    if (!value) {
        return null;
    }

    return dayjs(value).format('MM/DD/YYYY');
}
